import { React, useState, useEffect, useContext } from "react";
import UserContext from "../components/User_Context.js";
import { GoogleLogin } from "@react-oauth/google";
import { GoogleOAuthProvider } from "@react-oauth/google";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";

function Login_Screen(params) {
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const { doLogon, doGoogleLogon } = useContext(UserContext);
  let oAuthGoogle = process.env.REACT_APP_GOOGLE_OAUTH_CLIENT_ID;

  useEffect(() => {
    (async () => {

      window.$(".deznav").hide();
      window.$(".content-body").removeClass("content-body");
      window.$("#main-wrapper").addClass("menu-toggle");
      window.$(".hamburger").parent().hide();
      window.$(".header-content").hide();
      window.$(".nav-header").hide();
      window.$(".page-titles").hide();
      window.$(".header").hide();
    })();
  }, []);

  const logon = async () => {
    setIsLoading(true);
    var result = await doLogon({ userName, password });

    if (result.success) {
      if (window.document.location.href.toLowerCase().includes("/login")) {
        window.document.location.href = "/";
      } else {
        window.document.location.reload();
      }
      setIsLoading(false);
    } else {
      withReactContent(Swal).fire({
        title: "Errore!!",
        icon: "info",
        text: "Qualcosa è andato storto!!",
        allowOutsideClick: true,
      });
      setIsLoading(false);
    }
  };

  useEffect(() => {
    (async () => {
      window.$(".deznav").hide();
      window.$(".content-body").removeClass("content-body");
      window.$("#main-wrapper").addClass("menu-toggle");
      window.$(".hamburger").parent().hide();
      window.$(".header-content").hide();
      window.$(".nav-header").hide();
      window.$(".page-titles").hide();
      window.$(".header").hide();
    })();
  }, []);

  //#region google login
  const responseMessageGoogle = async (response) => {
    // console.log(response.credential);

    var googleLogonMethod = await doGoogleLogon(response);

    if (googleLogonMethod.success) {
      if (window.document.location.href.toLowerCase().includes("/login")) {
        window.document.location.href = "/";
      } else {
        window.document.location.reload();
      }
    } else {
      withReactContent(Swal).fire({
        title: "Errore!!",
        icon: "info",
        text: "Il tuo indirizzo email non è autorizzato a entrare con Google",
        allowOutsideClick: true,
      });
    }
  };

  function errorMessageGoogle(response) {
    withReactContent(Swal).fire({
      title: "OOOPSS!!",
      icon: "info",
      text: "Ci sono stati problemi durante l'accesso con Google",
      allowOutsideClick: false,
    });
  }

  //#endregion

  return (
    <GoogleOAuthProvider clientId={oAuthGoogle}>
      <div className="container-fluid vh-100">
        <div className="row h-100">
          <div className="col-lg-6 col-md-12 col-sm-12 mx-auto align-self-center">
            <div className="login-form">
              <div className="text-center">
                <h3 className="title">Accedi</h3>
                <p>Accedi al tuo account per iniziare a usare AI Plan</p>
              </div>
              <div className="mb-4">
                <label className="mb-1 text-dark">Username</label>
                <input
                  type="userName"
                  className="form-control form-control"
                  value={userName}
                  placeholder="Inserisci il tuo username"
                  onChange={(e) => {
                    setUserName(e.target.value);
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      return logon();
                    }
                  }}
                />
              </div>
              <div className="mb-4 position-relative">
                <label className="mb-1 text-dark">Password</label>
                <input
                  type="password"
                  id="dz-password"
                  className="form-control"
                  value={password}
                  placeholder="Inserisci la tua password"
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      return logon();
                    }
                  }}
                  onChange={(e) => {
                    setPassword(e.target.value);
                  }}
                />
                <span className="show-pass eye">
                  <i className="fa fa-eye-slash"></i>
                  <i className="fa fa-eye"></i>
                </span>
              </div>
              {/* <div className="form-row d-flex justify-content-between mt-4 mb-2">
                                <div className="mb-4">
                                    <div className="form-check custom-checkbox mb-3">
                                        <input type="checkbox" className="form-check-input" id="customCheckBox1" required="" />
                                        <label className="form-check-label" for="customCheckBox1">Remember my preference</label>
                                    </div>
                                </div>
                                <div className="mb-4">
                                    <a href="page-forgot-password.html" className="btn-link text-primary">Forgot Password?</a>
                                </div>
                            </div> */}
              <div className="text-center mb-4">
                <button
                  type="button"
                  className="btn btn-primary btn-block"
                  onClick={logon}
                  disabled={isLoading}
                >
                  {isLoading ? (
                    <i className="fa fa-spinner fa-spin"></i>
                  ) : (
                    "Accedi"
                  )}
                </button>
              </div>
              <h6 className="login-title">
                <span>Oppure continua con</span>
              </h6>

              <div className="mb-3">
                <ul className="d-flex align-self-center justify-content-center">
                  {/* <li className="me-2"><a target="_blank" href="https://www.facebook.com/" className="fab fa-facebook-f btn-facebook"></a></li> */}
                  <li className="me-2">
                    {" "}
                    <div id="btnGoogle">
                      <GoogleLogin
                        shape="pill"
                        text="signin"
                        type="icon"
                        theme="filled_blue"
                        width="150"
                        onSuccess={responseMessageGoogle}
                        onError={errorMessageGoogle}
                      />
                    </div>
                  </li>
                  {/* <li className="me-2"><a target="_blank" href="https://www.linkedin.com/" className="fab fa-linkedin-in btn-linkedin me-2"></a></li>
                                    <li className="me-2"><a target="_blank" href="https://twitter.com/" className="fab fa-twitter btn-twitter"></a></li> */}
                </ul>
              </div>
              {/* <p className="text-center">Not registered?
                                <a className="btn-link text-primary" href="page-register.html">Register</a>
                            </p> */}
            </div>
          </div>
          <div className="col-xl-6 col-lg-6">
            <div className="pages-left h-100">
              <div className="login-content">
                <h2>AI PLAN</h2>

                <p dangerouslySetInnerHTML={{
                  __html: "AI Plan è un tool utente-friendly, basato sull'<strong>Intelligenza Artificiale</strong>, per un processo di controllo interno più efficiente e più semplice."
                }}></p>

                <p>
                  &copy; {new Date().getFullYear()} by{" "}
                  <a href="https://www.besmart.it">Be Smart</a> &{" "}
                  <a href="https://qnomos.com">Nomos</a>
                </p>
              </div>
              <div className="login-media text-center">
                <img src="images/login.png" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </GoogleOAuthProvider>
  );
}

export { Login_Screen };
